import React from 'react';
import Link from 'next/link';
import classNames from 'classnames';
import { Icon } from '../../subkit-ui';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TWMenuItem = function TWMenuItem(_ref) {
  var item = _ref.item;
  var currentIcon = item.active ? 'check' : item.icon ? item.icon : null;
  return /*#__PURE__*/_jsx("li", {
    role: "option",
    className: classNames("list-style-none text-gray-900  hover:bg-gray-100 cursor-pointer relative ".concat(item.customClassName, " "), {
      'list-style-none bg-yellow-400 hover:bg-yellow-400 cursor-default font-medium': item.active
    }),
    onClick: item.onClick,
    "data-tip": item.dataTip,
    children: item.href ? /*#__PURE__*/_jsx(Link, {
      href: item.href,
      children: /*#__PURE__*/_jsxs("a", {
        className: "block py-2 pl-3 md:pl-4 pr-9 relative sm: p-0",
        children: [/*#__PURE__*/_jsx("span", {
          className: "font-sans text-base block truncate mr-4 ".concat(item.customClassName),
          children: item.text
        }), currentIcon && /*#__PURE__*/_jsx("span", {
          className: "text-gray-900 absolute inset-y-0 right-0 flex items-center pr-4",
          children: /*#__PURE__*/_jsx(Icon, {
            type: "regular",
            name: currentIcon
          })
        })]
      })
    }) : /*#__PURE__*/_jsxs("span", {
      className: "block py-2 pl-3 md:pl-4 pr-9 relative",
      children: [/*#__PURE__*/_jsx("span", {
        className: "font-sans text-base block truncate mr-4 ".concat(item.customClassName),
        children: item.text
      }), currentIcon && /*#__PURE__*/_jsx("span", {
        className: "text-gray-900 absolute inset-y-0 right-0 flex items-center pr-4",
        children: /*#__PURE__*/_jsx(Icon, {
          type: "regular",
          name: currentIcon
        })
      })]
    })
  });
};